import { storePasien } from "@/store/modules/pasien";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import type { IdentitasRingkas } from "@/types/order_darah";

export function identitasDariStore(register: string | number): IdentitasRingkas {
  const p: any = storePasien.identitasPasien;
  const reg: any = RegisterKunjungan.register;

  let jaminan: string | null = null;
  if (reg && String(reg.no) === String(register) && reg.asuransi) {
    jaminan = reg.asuransi;
  } else if (p && p.register && String(p.register.no) === String(register)) {
    jaminan = p.register.asr ? p.register.asr.nama : null;
  }

  return {
    nama: (p && p.nama) || "-",
    jk: (p && p.jk) || "-",
    usia: (p && p.usia) || "-",
    alamat: (p && p.alamat) || "-",
    jaminan: jaminan || "-"
  };
}
